import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import alert from "components/elements/Alert";

import { Checkbox, Collapse, message, Space, Switch } from "antd";
import { generateRandomString } from "utils/helper";
import * as services from "../services/rolePermissionApi";
import {
  setCurrentPermission,
  setDropdownRole,
  setIsLoading,
  setRoles,
} from "../slices/userSlice";
import styles from "../styles/UserPermission.module.css";

function useUserPermission() {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const currentCompany = useSelector((state) => state.company.currentCompany);
  const roles = useSelector((state) => state.user.roles);
  const hasRole = (code, action) => roles.includes(`${action}_${code}`);
  const isLoading = useSelector((state) => state.user.isLoading);
  const { dropdownRole, currentPermission } = useSelector((state) => state.user);

  const [selectedRole, setSelectedRole] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const ref = useRef(null)
  const [showSave, setShowSave] = useState(false)
  const [dataForSave, setDataForSave] = useState([])

  const [initialRoles, setInitialRoles] = useState([]);

  // const submit = useCallback(
  //   () => {
  //     saveRolesToApi({
  //       data: [...roles.map(o => {
  //         return {
  //           roleId: selectedRole?.[0],
  //           permissions: {
  //             ...o
  //           }
  //         }
  //       })]
  //     })
  //   },
  //   [dataForSave],
  // )
  const submit = useCallback(() => {
    const roleSet = new Set(roles);
    roleSet.add("ACCESS_HOME");
    roleSet.add("TOGGLE_HOME");
    roleSet.add("ACCESS_PROFILE");
    roleSet.add("TOGGLE_PROFILE");

    const data = {
      roleId: selectedRole?.[0],
      allowPermission: Array.from(roleSet),
      companyId: currentCompany,
    };

    updateAllowRolePermission(data);
  }, [currentCompany, roles, selectedRole]);




  function resetData() {
    setDataForSave([])
    if (currentPermission?.length) {
      setSelectedData({ ...currentPermission?.find(o => o.roleId == selectedRole?.[0]) });
    }
    dispatch(setRoles(initialRoles));
    setActiveKey([])
  }

  const roleOptions = useMemo(() => {
    return dropdownRole.map((opt) => ({
      ...opt,
      key: opt.id,
      label: i18n.language === "en" ? opt.roleNameEn : opt.roleName,
      value: opt.id,
    }));
  }, [dropdownRole, i18n.language]);

  const getDropdownRole = useCallback(async () => {
    try {
      dispatch(setIsLoading(true));
      const response = await services.getDropdownRole({
        requestId: generateRandomString(),
        companyId: currentCompany,
      });
      dispatch(setDropdownRole(response.data || []));
    } catch (error) {
      alert({ type: "error", resultObject: error });
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, dispatch]);

  const getAllowRolePermissionByRoleId = useCallback(
    async (roleId) => {
      try {
        dispatch(setIsLoading(true));
        const response = await services.allowRolePermissionByRoleId({ roleId });
        dispatch(setRoles(response.data));
        setInitialRoles(response.data);
      } catch (error) {
        alert({ type: "error", resultObject: error });
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [dispatch]
  );

  const onRoleSelect = useCallback((key) => {
    resetData();
    setSelectedRole([key]);
    if (currentPermission && key) {
      const roleData = currentPermission.find((o) => o.roleId === key);

      setSelectedData({ ...roleData });
      getAllowRolePermissionByRoleId(key);
    }
  }, [currentPermission, getAllowRolePermissionByRoleId]);

  const getPermissionByRoleId = useCallback(
    async (roleId) => {
      if (currentCompany)
        try {
          dispatch(setIsLoading(true));
          const response = await services.getPermissionAllRole({
            requestId: generateRandomString(),
            companyId: currentCompany,
            roleId,
            page: 0,
            size: 10000
          });
          const newPermissions = response.data?.page.content || [];
          dispatch(setCurrentPermission(newPermissions));

          if (roleId && newPermissions.length > 0) {
            const roleData = newPermissions.find(o => o.roleId === roleId);
            if (roleData) {
              setSelectedData({ ...roleData });
            }
          }
        } catch (error) {
          alert({ type: "error", resultObject: error });
        } finally {
          dispatch(setIsLoading(false));
        }
    },
    [currentCompany, dispatch]
  );


  useEffect(() => {
    if (typeof currentCompany !== "object") {
      getDropdownRole();
    }
  }, [currentCompany, getDropdownRole]);

  useEffect(() => {
    if (roleOptions.length > 0 && !selectedRole.length && currentCompany) {
      const firstRole = roleOptions[0];
      setSelectedRole([firstRole.id]);
    }
  }, [roleOptions, currentCompany, selectedRole.length]);

  useEffect(() => {
    if (selectedRole.length > 0 && currentCompany) {
      const roleId = selectedRole[0];
      getAllowRolePermissionByRoleId(roleId);
      getPermissionByRoleId(roleId);
    }
  }, [selectedRole, currentCompany, getAllowRolePermissionByRoleId, getPermissionByRoleId]);

  useEffect(() => {
    setSelectedRole([]);
  }, [currentCompany])

  const [activeKey, setActiveKey] = useState([])


  // const onClickForadd = useCallback(
  //   ({ e, record, access }) => {
  //     // onClickRole({ ...record, [access]: e ? 'Y' : 'N' })
  //     console.log("selectedData", selectedData);
  //     const actionCode = `${access}_${record.code}`;
  //     const accessCode = `ACCESS_${record.code}`;
  //     const toggleCode = `TOGGLE_${record.code}`;

  //     let updatedRoles = "";

  //     if (access === "TOGGLE") {
  //       updatedRoles = e
  //         ? [...roles, accessCode, toggleCode]
  //         : roles.filter((role) => role !== accessCode && role !== toggleCode);
  //     } else {
  //       updatedRoles = e
  //         ? [...roles, actionCode]
  //         : roles.filter((role) => role !== actionCode);
  //     }

  //     dispatch(setRoles(updatedRoles));
  //     let temp = [...dataForSave]
  //     console.log("temp", temp, dataForSave);

  //     if (temp?.find(o => o.code == record.code) != null) {
  //       let temp2 = temp?.map(o => {
  //         console.log("o.code", o.code, record.code);
  //         if (o.code == record.code) {
  //           if (access == 'ACCESS' && e == false) {
  //             return {
  //               ...o,
  //               [access]: e ? 'Y' : 'N',
  //               "allowCreate": e ? 'Y' : 'N',
  //               "allowUpdate": e ? 'Y' : 'N',
  //               "allowDelete": e ? 'Y' : 'N'
  //             }
  //           } else if (access == 'ACCESS' && e == true) {
  //             return { ...o, [access]: e ? 'Y' : 'N' }
  //           } else if (access != 'ACCESS' && e == true) {
  //             return {
  //               ...o,
  //               [access]: e ? 'Y' : 'N',
  //               "allowAccess": e ? 'Y' : 'N',
  //             }
  //           }
  //           else {
  //             return { ...o, [access]: e ? 'Y' : 'N' }
  //           }
  //         } else {
  //           return {
  //             ...o,
  //           }
  //         }
  //       })
  //       setDataForSave([...temp2])
  //     } else {
  //       // console.log("access code", e, initialRoles, record, access, temp, temp?.find(o => o.code == record.code) != null);
  //       // record.
  //       // console.log("initialRoles", String(record.code).includes(""), );
  //       let init = initialRoles.filter(o => {
  //         return o.includes(record.code) || record.code.includes(o)
  //       })
  //       console.log("init", record.code, init, temp);

  //       if (access == 'ACCESS' && e == false) {
  //         temp.push({
  //           ...record,
  //           "ACCESS": init.includes(`ACCESS_${record.code}`) ? 'Y' : 'N',
  //           "CREATE": init.includes(`CREATE_${record.code}`) ? 'Y' : 'N',
  //           "UPDATE": init.includes(`UPDATE_${record.code}`) ? 'Y' : 'N',
  //           "DELETE": init.includes(`DELETE_${record.code}`) ? 'Y' : 'N',
  //           [access]: e ? 'Y' : 'N',
  //           "allowCreate": e ? 'Y' : 'N',
  //           "allowUpdate": e ? 'Y' : 'N',
  //           "allowDelete": e ? 'Y' : 'N'
  //         })
  //         setDataForSave([...temp])
  //       } else if (access == 'ACCESS' && e == true) {
  //         console.log("2");
  //         temp.push({
  //           ...record,
  //           "ACCESS": init.includes(`ACCESS_${record.code}`) ? 'Y' : 'N',
  //           "CREATE": init.includes(`CREATE_${record.code}`) ? 'Y' : 'N',
  //           "UPDATE": init.includes(`UPDATE_${record.code}`) ? 'Y' : 'N',
  //           "DELETE": init.includes(`DELETE_${record.code}`) ? 'Y' : 'N',
  //           [access]: e ? 'Y' : 'N',
  //         })
  //         setDataForSave([...temp])
  //       } else if (access != 'ACCESS' && e == true) {
  //         console.log("3");
  //         temp.push({
  //           ...record,
  //           "ACCESS": init.includes(`ACCESS_${record.code}`) ? 'Y' : 'N',
  //           "CREATE": init.includes(`CREATE_${record.code}`) ? 'Y' : 'N',
  //           "UPDATE": init.includes(`UPDATE_${record.code}`) ? 'Y' : 'N',
  //           "DELETE": init.includes(`DELETE_${record.code}`) ? 'Y' : 'N',
  //           [access]: e ? 'Y' : 'N',
  //           "allowAccess": e ? 'Y' : 'N',
  //         })
  //         setDataForSave([...temp])
  //       }
  //       else {
  //         console.log("4");
  //         temp.push({
  //           ...record,
  //           "ACCESS": init.includes(`ACCESS_${record.code}`) ? 'Y' : 'N',
  //           "CREATE": init.includes(`CREATE_${record.code}`) ? 'Y' : 'N',
  //           "UPDATE": init.includes(`UPDATE_${record.code}`) ? 'Y' : 'N',
  //           "DELETE": init.includes(`DELETE_${record.code}`) ? 'Y' : 'N',
  //           [access]: e ? 'Y' : 'N'
  //         })
  //         setDataForSave([...temp])
  //       }

  //     }
  //   },[dataForSave, roles, setDataForSave, initialRoles],)

  // const updatePermission = useCallback(
  //   async (values = {}) => {
  //     try {
  //       dispatch(setIsLoading(true));
  //       await services.updatePermission({ ...values, companyId: currentCompany });
  //       alert({ message: "Success" });
  //       getPermissionByRoleId();
  //     } catch (error) {
  //       alert({ type: "error", resultObject: error });
  //     } finally {
  //       setDataForSave([])
  //       dispatch(setIsLoading(false));
  //       setSelectedData([])
  //     }
  //   },
  //   [currentCompany, dispatch]
  // );

  const updateAllowRolePermission = useCallback(
    async (values = {}) => {
      const currentRoleId = values.roleId;

      try {
        dispatch(setIsLoading(true));
        await services.updateAllowRolePermission({
          ...values
        });
        message.success(t("common.successsfull"));

        await getPermissionByRoleId(currentRoleId);
        await getAllowRolePermissionByRoleId(currentRoleId);

      } catch (error) {
        alert({ type: "error", resultObject: error });
      } finally {
        setDataForSave([])
        setShowSave(false)
        dispatch(setIsLoading(false));
      }
    },
    [dispatch, getPermissionByRoleId, getAllowRolePermissionByRoleId]
  );


  // const checked = useCallback(
  //   (data, allow) => {
  //     if (dataForSave.find(o => data.code == o.code) != null) {
  //       return ({ checked: dataForSave.some(item => item.code == data.code && item?.[allow] == 'Y') })
  //     } else {
  //       return null
  //     }
  //   },
  //   [dataForSave],
  // )

  const checked = useCallback(
    (data, action) => {
      if (!data || !action) return { checked: false, disabled: false }; // Ensure data and action are valid
      const savedItem = dataForSave.find(o => o.code === data.code);
      if (savedItem) {
        return { checked: savedItem[action] === 'Y', disabled: false };
      } else {
        const hasRole = roles.includes(`${action}_${data.code}`);
        return { checked: hasRole, disabled: false };
      }
    },
    [dataForSave, roles]
  );

  const onClickForadd = useCallback(
    ({ e, record, access }) => {
      setShowSave(true);
      const actionCode = `${access}_${record.code}`;
      const accessCode = `ACCESS_${record.code}`;
      const toggleCode = `TOGGLE_${record.code}`;

      let updatedRoles = access === "TOGGLE" ?
        e ? [...roles, accessCode, toggleCode] : roles.filter(role => role !== accessCode && role !== toggleCode) :
        e ? [...roles, actionCode] : roles.filter(role => role !== actionCode);

      dispatch(setRoles(updatedRoles));

      let updatedData = dataForSave.map((o) => {
        if (o.code === record.code) {
          const newState = e ? 'Y' : 'N';
          if (access === 'ACCESS' && newState === 'N') {
            return {
              ...o,
              [access]: newState,
              ...(newState === 'N' && {
                CREATE: 'N',
                UPDATE: 'N',
                DELETE: 'N',
                TOGGLE: 'N'
              })
            };
          } else {
            return { ...o, [access]: newState };
          }
        }
        return o;
      });

      if (!dataForSave.some(o => o.code === record.code)) {
        if (access === 'ACCESS' && !e) {
          updatedData.push({
            ...record,
            ACCESS: e ? 'Y' : 'N',
            CREATE: e ? record.CREATE || 'Y' : 'N',
            UPDATE: e ? record.UPDATE || 'Y' : 'N',
            DELETE: e ? record.DELETE || 'Y' : 'N',
            TOGGLE: e ? record.TOGGLE || 'Y' : 'N'
          });
        }
      }
      setDataForSave(updatedData);
    },
    [dataForSave, roles, setDataForSave, dispatch]
  );



  const RecursiveConfigChild = useCallback(
    ({ item }) => {
      const language = i18n.language == "en" ? "En" : ""
      return item?.childComponents?.map(o => {


        const getClassNameInchild = () => {
          return item?.childComponents !== null ? styles.headerInnerInside : styles.headerInnerInsideChild
        }


        return (
          <Collapse ghost
            bordered={false}
            className={styles.headerCollapseInsider}
            style={{
              padding: 0
            }}
            size="large"
            activeKey={activeKey}
            // expandIconPosition="end"
            collapsible={'icon'}
            // destroyInactivePanel={true}
            header={o.name}
            onChange={(e) => {
              setActiveKey([...e])
            }}
            items={[{
              ...o,
              key: o.code,
              showArrow: o.childComponents != null,
              label: <div className={getClassNameInchild()}>
                <div>{o?.["name" + language]}</div>
                {(o.hasAccess == 'N' || o.hasToggle == 'Y') ? <div /> : <Checkbox {...checked(o, 'ACCESS')} onClick={(e) => {
                  // console.log("click");
                  onClickForadd({ e: e.target.checked, record: o, access: 'ACCESS' })
                }} style={{ justifyContent: "center" }}></Checkbox>}
                {o.hasCreate == 'N' ? <div /> : <Checkbox  {...checked(o, 'CREATE')} onClick={(e) => onClickForadd({ e: e.target.checked, record: o, access: 'CREATE' })} style={{ justifyContent: "center" }}></Checkbox>}
                {o.hasUpdate == 'N' ? <div /> : <Checkbox  {...checked(o, 'UPDATE')} onClick={(e) => onClickForadd({ e: e.target.checked, record: o, access: 'UPDATE' })} style={{ justifyContent: "center" }}></Checkbox>}
                {o.hasDelete == 'N' ? <div /> : <Checkbox  {...checked(o, 'DELETE')} onClick={(e) => onClickForadd({ e: e.target.checked, record: o, access: 'DELETE' })} style={{ justifyContent: "center" }}></Checkbox>}
                <div>
                </div>
                <Space size={10}></Space>
              </div>,
              value: false,
              extra: o.hasToggle == 'Y' && <Switch {...checked(o, 'TOGGLE')} style={{
                marginLeft: "20px"
              }} onClick={(e) => {
                onClickForadd({ e, record: o, access: "TOGGLE" })
              }}></Switch>,
              children: (
                <>
                  {/* {RecursiveConfigChild({ item: o })} */}
                  <RecursiveConfigChild item={o} />
                </>
              )
            }]}
          >
          </Collapse>
        )
      })
    },
    [selectedData, checked, dataForSave, activeKey, isLoading, i18n, onClickForadd, roles],
  )

  // function checked(data, dataForSave) {
  //   if (dataForSave.find(o => data.code == o.code) != null) {
  //     return ({ checked: dataForSave.some(item => item.code == data.code && item.allowAccess == 'Y') })
  //   } else {
  //     return null
  //   }
  // }


  const RecursiveConfig = useCallback(
    ({ }) => {
      const language = i18n.language == "en" ? "En" : ""
      return selectedData?.permissions?.map(o => {
        const code = o.code;
        // console.log("🚀 ~ useUserPermission ~ code:", code)
        return <><Collapse
          ghost
          bordered={false}
          className={styles.headerCollapse}
          size="large"
          activeKey={activeKey}
          onChange={(e) => {
            setActiveKey([...e])
          }}
          // expandIconPosition="end"
          collapsible={'icon'}
          items={[{
            ...o,
            showArrow: o.childComponents != null,
            key: o.code,
            // style:
            //   { borderRadius: '1rem' }
            // ,
            label: <div className={styles.headerInner}>
              <div>{o?.["name" + language]}</div>
              {(o.hasAccess == 'N' || o.hasToggle == 'Y') ? <div /> : <Checkbox  {...checked(o, 'ACCESS')} onClick={(e) => {
                console.log("click2");
                onClickForadd({ e: e.target.checked, record: o, access: 'ACCESS' })
              }} style={{ justifyContent: "center" }}></Checkbox>}
              {o.hasCreate == 'N' ? <div /> : <Checkbox  {...checked(o, 'CREATE')} onClick={(e) => onClickForadd({ e: e.target.checked, record: o, access: 'CREATE' })} style={{ justifyContent: "center" }}></Checkbox>}
              {o.hasUpdate == 'N' ? <div /> : <Checkbox  {...checked(o, 'UPDATE')} onClick={(e) => onClickForadd({ e: e.target.checked, record: o, access: 'UPDATE' })} style={{ justifyContent: "center" }}></Checkbox>}
              {o.hasDelete == 'N' ? <div /> : <Checkbox  {...checked(o, 'DELETE')} onClick={(e) => onClickForadd({ e: e.target.checked, record: o, access: 'DELETE' })} style={{ justifyContent: "center" }}></Checkbox>}
              <div></div>
            </div>,
            extra: o.hasToggle == 'Y' &&
              <Switch
                {...checked(o, 'TOGGLE')}
                style={{
                  marginLeft: "20px"
                }}
                onClick={(e) => {
                  onClickForadd({ e, record: o, access: "TOGGLE" })
                }}
              />,
            children: (
              <>
                <RecursiveConfigChild item={o} />
                {/* {RecursiveConfigChild({ item: o })} */}
                {/* </Space> */}
              </>
            )
            // children: RecursiveConfigChild(o.childComponents)
          }]}
        >
        </Collapse >
          {/* <Divider style={{
            marginTop: 10,
            marginBottom: 10,
            border: 0
          }} /> */}
        </>
      })
    },
    [RecursiveConfigChild, checked, dataForSave, activeKey, selectedData],
  )

  return {
    isLoading,
    selectedRole,
    roleOptions,
    selectedData,
    setSelectedData,
    ref,
    submit,
    resetData,
    onRoleSelect,
    RecursiveConfig,
    dataForSave,
    showSave
  };
}

export default useUserPermission;
